import React from 'react';
import RichText from 'components/RichText';
import WistiaVideo from 'components/Core/WistiaVideo';
import WebsiteImage from 'components/WebsiteImage';
import richTextOptions from './richTextOptions';

export const FeaturedImage = ({ image, video }) => {
  const itemType =
    image?.image?.file?.contentType === 'video/mp4' ||
    image?.bynderDesktopImage?.[0]?.videoPreviewURLs?.[0]?.endsWith('mp4')
      ? 'mp4'
      : video
      ? 'wistiaVideo'
      : 'image';

  return itemType === 'image' || itemType === 'mp4' ? (
    <WebsiteImage {...image} />
  ) : (
    <WistiaVideo dataPosition="In-Page Features" url={video?.sharableLink} />
  );
};

export const FeaturedCopy = ({ className, description, link }) => {
  return (
    <div className={className}>
      <RichText content={description} options={richTextOptions} />
      {link && <a href={link}>Learn More</a>}
    </div>
  );
};

const FeaturedContent = ({ item }) => {
  const { link, featuredImage, featuredVideo, description } = item || {};

  return (
    <>
      <FeaturedImage image={featuredImage} video={featuredVideo} />
      <FeaturedCopy className="mt-[20px] px-[20px]" description={description} link={link} />
    </>
  );
};

export default FeaturedContent;
